import { render } from "./FieldHidden.vue?vue&type=template&id=6b820e28"
import script from "./FieldHidden.vue?vue&type=script&lang=js"
export * from "./FieldHidden.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__